import i18next from 'i18next'
import { notifyToast } from '../../../../helper'

export const getActiveBreakDateTo = (orderType) =>
	(orderType.breakDateTo && new Date(orderType.breakDateTo).getTime() > Date.now() ? orderType.breakDateTo : null)

export const isOrderTypeClosed = (orderType) => !orderType.working || !!getActiveBreakDateTo(orderType)

export const notifyFranchiseChange = (data) => {
	if (!data.changedByFranchise) return
	notifyToast({
		message: i18next.t('onlinePlatforms.changedByFranchise', {
			franchiseName: data.franchiseName,
			franchiseCompanyIndex: data.franchiseCompanyIndex,
		}),
	}, 'info')
}
